import React from 'react';
import { EnvironmentEffects } from '@/components/effects/EnvironmentEffects';
import { useTheme } from '@/context/ThemeContext';

/**
 * Wrapper component that applies environmental effects based on current theme
 * Should be placed at the root level of the public site
 */
export const ThemeEffectsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <>
      <EnvironmentEffects 
        theme={theme}
        enableMouseGlow={true}
        enableGrain={true}
        enableScanlines={true}
        enableVignette={true}
      />
      {children}
    </>
  );
};
